(function () {
  'use strict';
  if (window.__ccGiftSyncInit) return;
  window.__ccGiftSyncInit = true;

  var GIFT_VARIANT_ID = 51443369017623;
  var GIFT_PROPERTY_KEY = '_Auto Gift';
  var syncing = false;
  var pendingResync = false;
  var debounceTimer = null;

  function getClearanceQty() {
    var el = document.getElementById('cc-clearance-gift-sync-data');
    return el ? parseInt(el.getAttribute('data-clearance-qty'), 10) || 0 : 0;
  }

  function findGiftLine(items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.variant_id === GIFT_VARIANT_ID && item.properties && item.properties[GIFT_PROPERTY_KEY]) {
        return { item: item, line: i + 1 };
      }
    }
    return null;
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clearance-gift-sync', cartData: cartData });
    }
  }

  async function runSync() {
    if (syncing) {
      pendingResync = true;
      return;
    }
    syncing = true;

    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var desired = Math.floor(getClearanceQty() / 3);
      var found = findGiftLine(cart.items);
      var currentQty = found ? found.item.quantity : 0;
      var changed = false;

      if (desired !== currentQty) {
        changed = true;
        if (desired === 0) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: found.line, quantity: 0 }),
          });
        } else if (!found) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: GIFT_VARIANT_ID, quantity: desired, properties: { '_Auto Gift': 'yes' } }],
            }),
          });
        } else {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: found.line, quantity: desired }),
          });
        }
      }

      syncing = false;

      if (changed) {
        var freshCart = await fetch('/cart.js').then(function (r) { return r.json(); });
        publishCartUpdate(freshCart);
      }

      if (pendingResync) {
        pendingResync = false;
        runSync();
      }
    } catch (e) {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runSync, 400);
  }

  function attachObserver() {
    var target = document.querySelector('cart-drawer');
    if (target && window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(target, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync();
    attachObserver();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'clearance-gift-sync') return;
        scheduleSync();
      });
    }

    setInterval(scheduleSync, 6000);
  });
})();
